<template>
  <div id="popupProdAdd" v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>

    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">{{title}}</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <ul class="rew19_transition_table in_popSearch">
          <li>
            <div class="right_btn">
              <div class="rew19_form_full">
                <input v-model="params.search_key"
                  @keyup.enter="searchProduct"
                  title="정기구매 상품 검색"
                  type="text" class="autoFocus rew19_inputTxt_t1"
                  placeholder="상품을 검색하세요">
              </div>
              <span class="type2">
                <a @click="searchProduct" class="rew19_btn_T1">검색</a>
              </span>
            </div>
          </li>
          <li class="type_mbFlex">
            <span class="rew19_form_full">
              <select v-model="params.division_code"
                @change="onChangeDivisionCode"
                class="rew19_select_t1 autoFocus">
                <option v-for="(item) in category_list" :key="item.division_code"
                  :value="item.division_code">{{item.division_name_kr}}</option>
              </select>
            </span>
            <span class="rew19_form_full">
              <select v-model="params.big_classcodes"
                @change="onChangeBigClasscodes"
                class="rew19_select_t1 autoFocus">
                <option v-for="(item) in division_list" :key="item.big_classcode"
                  :value="item.big_classcode">{{item.big_classcode_name}}</option>
              </select>
            </span>
          </li>
        </ul>

        <div v-if="!productList || productList.length <= 0"
          class="rew19_noData_wrap noIcon">
          <span class="rew19_noData">검색 결과가 없습니다.</span>
        </div>

        <ul class="rew19_goodsList rew19_clear">
          <li v-for="(product, idx) in productList" v-bind:key="product.pd_id+idx">
            <a class="rew19_aProduct">
              <div class="rew19_goodsWrap">
                <div class="rew19_goodsImg">
                  <span class="rew18_goodsDim" v-if="product.isSoldOut == 'Y'">
									  <em>일시품절</em>
									</span>
                  <i v-if="product.isRetention == 'Y'"
                    class="rew19_goodsFlag fourplus">4+1</i>
                  <span class="rew19_rateImg">
                    <img
                      :src="product.pd_img_url1"
                      :alt="product.pd_id"
                      onError="imageError(this)" data-error-cnt="0"
                    />
                  </span>
                </div>
                <button type="button"
                  @click.stop.prevent="onClickProductAdd(product)"
                  class="rew19_btn_putB">
                  <span class="rew19_icon_add">상품추가</span>
                </button>
              </div>
              <p class="rew19_goodsTxt">{{product.pd_name_kr}}</p>
              <p class="rew19_goodsPrice m">
                <em class="rew19_gTit">정기구매가</em>
                <span v-if="viewData.aro_payment_count >= 3" class="rew19_gDetail">
                  <strong >{{$fmt.WON(product.pd_amt2)}}</strong>원
                </span>
                <span v-else class="rew19_gDetail">
                  <strong >{{$fmt.WON(product.pd_amt1)}}</strong>원
                </span>
              </p>
              <p class="rew19_goodsPrice p">
                <em class="rew19_gTit">회원가</em>
                <span class="rew19_gDetail">{{$fmt.WON(product.membersPrice)}}원</span>
              </p>
            </a>
          </li>

        </ul>

      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popFull activation" @click="onCancel">닫기</button>
      </div>

    </div>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

const DEFAULT_VIEWDATA = {
  aro_payment_count : 1
};

export default {
  name: 'ProductAddDialog',
  components: {  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      require : true,
    },
    division_code: {
      type: String,
      default: "N"
    },
    big_classcodes: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentZIndex : 2000,

      category_list: [],
      division_list: [],

      params : {
        division_code: "N",
        big_classcodes: "",
        search_typ: "",
        search_key: ""
      },

      productList: [
        // {
        //   pd_id: "",
        //   pd_name_kr: "",
        //   pd_amt: "",
        //   pd_amt1: "",
        //   pd_img_url1: ""
        // }
      ],

      viewData : {...DEFAULT_VIEWDATA}
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      let headerHeight = $(".rew19_popContainer.big .rew19_popup_wrap").height();
      let btnHeight = $(".rew19_popContainer.big .rew19_popup_btn").height();
      //console.debug(`differ Height:${headerHeight+ btnHeight}`);
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height()
        - headerHeight - btnHeight);
    })
  },
  mounted() {
    let _this = this;

  },
  methods :{
    onClose(response) {
      this.$emit('close');
    },
    onCancel(){
      this.onClose(false);
    },

    /**
     * API Request
     */
    //카테고리 가져오기
    apiGetCategory : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/category`, {
        params: {}
      });
    },

    //중분류 가져오기
    apiGetDivision : function(divisionCode) {
      let _this = this;

      _this.params.division_code = divisionCode;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/division`, {
        params: {
          division_code: _this.params.division_code
        }
      });
    },

    //상품목록 가져오기
    apiGetProductList : function(divisionCode, bigClasscodes) {
      let _this = this;

      _this.params.division_code = divisionCode;
      _this.params.big_classcodes = bigClasscodes;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/list`, {
        params: {
          division_code: _this.params.division_code,
          big_classcode: _this.params.big_classcodes,
          search_typ: _this.params.search_key ? "S" : "",
          search_key: _this.params.search_key
        }
      });
    },

    /**
     * Local
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        ...paramData,
      };

      _this.loadList(_this.division_code, _this.big_classcodes);
    },

    //상품로드(초기)
    loadList : function(divisionCode, bigClasscodes) {
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetCategory().then(cateRes=>{
        if (cateRes.status === 200 && cateRes.data.status === "0000") {
          let list = cateRes.data.division_list;

          //Add additional info (url, etc...)
          list.forEach((item)=>{
            item.url = _this.$aroBasePath+`/list?division_code=${item.division_code}`;
          });
          _this.category_list = list;
        }

        return _this.apiGetDivision(divisionCode);
      }).then(bigCodesRes=>{

        if (bigCodesRes.status === 200 && bigCodesRes.data.status === "0000") {
          let division_list = bigCodesRes.data.division_list;

          //전체 보기 제거
          _this.division_list = division_list.map((item)=>{
            if(item.big_classcode != "") return item;

            item.big_classcode_name = "전체";

            return item;
          });
        }

        return _this.apiGetProductList(divisionCode, bigClasscodes);
      }).then(prodListRes=>{

        if (prodListRes.status === 200 && prodListRes.data.status === "0000") {
          _this.productList = [...prodListRes.data.pd_list];
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //대분류 코드 변경시
    onChangeDivisionCode(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetDivision(_this.params.division_code).then(bigCodesRes=>{

        if (bigCodesRes.status === 200 && bigCodesRes.data.status === "0000") {
          let division_list = bigCodesRes.data.division_list;

          //전체 보기 제거
          _this.division_list = division_list.map((item)=>{
            if(item.big_classcode != "") return item;

            item.big_classcode_name = "전체";

            return item;
          });

          _this.params.big_classcodes = _this.division_list[0].big_classcode;
        }

        return _this.apiGetProductList(_this.params.division_code, _this.params.big_classcodes);
      }).then(prodListRes=>{

        if (prodListRes.status === 200 && prodListRes.data.status === "0000") {
          _this.productList = [...prodListRes.data.pd_list];
        }
      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //중분류 코드 변경시
    onChangeBigClasscodes(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetProductList(
        _this.params.division_code,
        _this.params.big_classcodes
      ).then(prodListRes=>{

        if (prodListRes.status === 200 && prodListRes.data.status === "0000") {
          _this.productList = [...prodListRes.data.pd_list];
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //상품검색
    searchProduct(){
      let _this = this;
      _this.onChangeBigClasscodes();
    },

    //상품추가 클릭시
    onClickProductAdd(product){
      let _this = this;
      if(product.isSoldOut === 'Y'){
        _this.$dialogs.alert('품절된 상품입니다.').then(res => {});
      }else{
        _this.$emit('onProductAdd', product);
      }
    },

    imageError(img) {
      let _this = this;

      _this.$imageError(
        img
      );
    },
    /**
     * Util
     */
  }
}
</script>
<style>
#popupProdAdd .rew19_goodsList {min-width: inherit !important;margin-top:inherit !important;}
@media only screen and (min-width: 769px) {
  .rew19_popup_cont .rew19_goodsList li {width: 30% !important;margin-top: 25px !important;margin-left:5%;margin-right: inherit !important;margin-bottom: inherit !important;}
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ProductAddDialog.vue